import React from 'react';
import { resolveProductCardBadges } from '../storefront/productCardBadges';

/**
 * Stacked badges on product card media (top-left).
 */
export default function ProductCardBadges({ product, storeCopy, className = '' }) {
  const badges = resolveProductCardBadges(product, storeCopy);
  if (!badges.length) return null;

  return (
    <div className={`product-card-badges ${className}`.trim()} aria-hidden>
      {badges.map((b) => (
        <span key={b.key} className={`product-card-badges__pill product-card-badges__pill--${b.variant}`}>
          {b.label}
        </span>
      ))}
    </div>
  );
}
